module.exports = __webpack_public_path__ + "media/images/flextab-logo-192-93eb0703aeeef799ff567bd5e9ba72f9.png";